import Reveal from '@/components/feature/Reveal';
import { fanGroups } from '@/mocks/home';

export default function FanClub() {
  return (
    <section id="fanclub" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-accent-700 uppercase">
              <i className="ri-team-line" /> 粉丝团
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
              蹲新料的兄弟姐妹，都在这里
            </h2>
          </div>
          <a
            href="#download"
            className="shrink-0 inline-flex items-center gap-2 h-11 px-6 rounded-full bg-secondary-500 text-background-50 text-sm font-bold whitespace-nowrap hover:bg-secondary-600 transition-colors cursor-pointer"
          >
            <i className="ri-add-line" /> 申请开团
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {fanGroups.map((group, index) => (
            <Reveal key={group.name} delay={index * 70}>
              <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col hover:border-accent-300 transition-colors">
                <span className="w-12 h-12 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center text-2xl">
                  <i className={group.icon} />
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{group.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{group.desc}</p>
                <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
                  <span className="text-xs font-bold text-secondary-700 whitespace-nowrap">{group.members}</span>
                  <span className="text-xs font-bold text-primary-600 whitespace-nowrap cursor-pointer">入团</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}